import React from 'react';
import { useTranslation } from 'react-i18next';
import DownArrow from '../../../../assets/downArrow.svg';
import {
	ChannelType,
	DefaultPropertyType,
	DeliveryStatusFilterType,
	IDeliveryStatus,
} from '../../../../interface';
import {
	ChannelOptions,
	Instances,
	TimeDropDownOptions,
} from '../../../../constants';
import WidgetDropDown from '../../molecules/DropDown/Dropdown';
import HeaderTemplate from '../../templates/Header';
// import Hamburger from '../../molecules/WidgetHamburger';
import DownloadButton from '../../molecules/Download';

type HeaderPropsType = {
	filters: DeliveryStatusFilterType;
	onFilterChange: (filters: DeliveryStatusFilterType) => void;
	showChannelFilter?: boolean;
	showDropDownButton?: boolean;
	data?: IDeliveryStatus[];
};

const Header: React.FC<HeaderPropsType> = ({
	filters,
	showChannelFilter = true,
	showDropDownButton,
	onFilterChange,
	data
}) => {
	const { t } = useTranslation();

	const selectedChannel = ChannelOptions.find(
		({ value }) => value.toString().toLowerCase() === filters?.channel
	);

	const customChannelOptions = (): Array<DefaultPropertyType> => {
		let channels: Array<DefaultPropertyType> = [];
		channels.push({
			label: 'SMS',
			value: 'sms'
		});
		// if (data && data.length > 0 && data[0].channel_status.whatsapp) {
		// 	channels.push({
		// 		label: 'WhatsApp',
		// 		value: 'whatsapp'
		// 	})
		// }
		return channels;
	}

	const getDropdown = (
		options: Array<DefaultPropertyType>,
		onClick?: (data: any) => void,
		selectedItem?: DefaultPropertyType,
		title?: string
	) => (
			<WidgetDropDown
				title={title}
				trigger={'click'}
				placement={'bottom'}
				items={options}
				label={selectedItem?.label}
				icon={<img src={DownArrow} alt="arrow"/>}
				action={onClick}
			/>
		);

	const getTimeLabel = () => {
		const { timerange } = filters || {};
		const { start_time, end_time } = timerange || {};
		return TimeDropDownOptions.find(({ value }) => {
			const [start, end] = value as Array<string>;
			return start_time === start && end === end_time;
		});
	};

	const memoizedTime = React.useMemo(() => getTimeLabel(), [
		filters?.timerange?.end_time,
		filters?.timerange?.start_time,
	]);

	const onTimeRange = ([start, end]: Array<string>) => {
		onFilterChange({
			...filters,
			timerange: {
				start_time: start,
				end_time: end,
			},
		});
	};

	const onChannelChange = (channel: ChannelType) => {
		onFilterChange({
			...filters,
			channel,
		});
	};

	return (
		<HeaderTemplate title={t('deliveryStatusWidget')}>
			{showChannelFilter &&
				getDropdown(customChannelOptions(), onChannelChange, selectedChannel)}
			{getDropdown(TimeDropDownOptions, onTimeRange, memoizedTime)}
			{/* <Hamburger /> */}
			{showDropDownButton && (
				<DownloadButton
					instanceId={Instances.deliveryStatusDetailed}
					message={t(`deliveryReport${filters?.channel}Download`)}
					params={filters}
				/>
			)}
		</HeaderTemplate>
	);
};
export default Header;
